import { render, staticRenderFns } from "./SquareCard.vue?vue&type=template&id=65742d1a"
import script from "./SquareCard.vue?vue&type=script&lang=js"
export * from "./SquareCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports